module.exports = __webpack_public_path__ + "public/images/program/program-22.de02787794797f5b804d7d3eecc6000e.png";